module.exports = __webpack_public_path__ + "static/media/c02-01-5.a62a3885.png";